import { render, staticRenderFns } from "./chatView.vue?vue&type=template&id=00ca0f78&scoped=true"
import script from "./chatView.vue?vue&type=script&lang=js"
export * from "./chatView.vue?vue&type=script&lang=js"
import style0 from "./chatView.vue?vue&type=style&index=0&id=00ca0f78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ca0f78",
  null
  
)

export default component.exports